/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcProxyvoteV1ProxyJobState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PROXYVOTE_V1_PROXY_JOB_STATE_ENTITY_NAME = 'ixc.proxyvote.v1.ProxyJob';
export const ixcProxyvoteV1ProxyJobStateEntity = new schema.Entity<IxcProxyvoteV1ProxyJobState>(IXC_PROXYVOTE_V1_PROXY_JOB_STATE_ENTITY_NAME, {}, { idAttribute: 'jobId' });

